<template>
  <div class="dots-icon" :style="{ '--color': color }">
    <q-btn flat round size="xs">
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </svg>

      <RPopup :items="popupItems" v-on="$listeners" />
    </q-btn>
  </div>
</template>

<script>
import RPopup from '@/ui/RPopup'

export default {
  components: {
    RPopup
  },

  props: {
    popupItems: Array,
    color: {
      type: String,
      default: 'var(--r-secondary-1)'
    }
  }
}
</script>

<style lang="scss" scoped>
.dots-icon {
  svg path {
    fill: var(--color);
  }
}
</style>
